export const tagsList = {
  "thunderstorm with light rain": "lofi",
  "thunderstorm with rain": "sadcore",
  "thunderstorm with heavy rain": "hardcore+punk",
  "light thunderstorm": "dubstep",
  thunderstorm: "punk",
  "heavy thunderstorm": "heavy+metal",
  "ragged thunderstorm": "folk+metal",
  "thunderstorm with light drizzel": "easy+listening",
  "thunderstorm with drizzle": "jungle",
  "thunderstorm with heavy drizzle": "crust+punk",
  "light intensit drizzle": "ambient+pop",
  "heavy intensity drizzle rain": "psychedelic",
  "shower rain and drizzle": "math+rock",
  "heavy shower rain and drizzle": "noise+pop",
  "shower drizzle": "atmospheric+pop",
  "light rain": "folk+rock",
  "moderate rain": "rnb",
  "heavy intensity rain": "house",
  "very heavy rain": "deep+house",
  "extreme rain": "dream+pop",
  "freezing rain": "fusion",
  "light intensity shower rain": "instrumental+hip+hop",
  "shower rain": "jazz",
  "heavy intensity shower rain": "experimental",
  "ragged shower rain": "chiptune",
  "light snow": "indie+pop",
  Snow: "art+pop",
  "Heavy snow": "dance",
  Sleet: "grunge",
  "Light shower sleet": "neo-classical",
  "Shower sleet": "progressive+rock",
  "Light rain and snow": "acoustic",
  "Rain and snow": "sludge",
  "Light shower snow": "ambient",
  "Shower snow": "reggae",
  "Heavy shower snow": "pop+punk",
  mist: "bossa+nova",
  Smoke: "new+wave",
  Haze: "drum+and+bass",
  "sand/ dust whirls": "country",
  fog: "idm",
  sand: "kpop",
  dust: "underground+hip+hop",
  "volcanic ash": "beach+music",
  squalls: "",
  tornado: "heavy+metal",
  "clear sky": "vaporwave",
  "few clouds": "disco",
  "scattered clouds": "hip+hop",
  "broken clouds": "soul",
  "overcast clouds": "blues",
};
